

export interface Disposable
{
    dispose(): void;
}

export namespace Disposable
{
    export function isDisposable(value: any): value is Disposable
    {
        return !!value?.dispose;
    }
}
